/*
 * PilotPoster component.
 */
import Container from '@components/atoms/container/posterContainer';
import Poster from '@components/atoms/images/poster';
import PosterDefault from '@shared/assets/images/png/posterDefault.png';
import { PilotPosterProps as Props } from '@shared/types/props/pilot';

/**
 * Displays the pilot poster. A default poster is displayed if no poster is provided.
 */
export default function PilotPoster({ id, poster }: Props) {
  return (
    <Container>
      <Poster key={id} src={poster || PosterDefault} />
    </Container>
  );
}
